import { PrivilegeCodes } from '../../../shared/RoleConstants';

export interface FeaturePrivilege {
	feature: string;
	privilegeCodes: string[];
}

export const FEATURE_PRIVILEGES: FeaturePrivilege[] = [
	{
		feature: 'Batches',
		privilegeCodes: [
			PrivilegeCodes.GET_BATCHES,
			PrivilegeCodes.CREATE_BATCH,
			PrivilegeCodes.UPDATE_BATCH,
			PrivilegeCodes.GET_ELIGIBLE_CANDIDATES_FOR_NEXT_BATCH,
			PrivilegeCodes.GET_APPLICATIONS,
		],
	},
	{
		feature: 'Registered Candidates',
		privilegeCodes: [PrivilegeCodes.GET_APPLICATION],
	},
	{
		feature: 'Proposer Load',
		privilegeCodes: [
			PrivilegeCodes.GET_PROPOSER_LOAD_SUMMARY,
			PrivilegeCodes.GET_ZONES_PROPOSER_LOAD_SUMMARY,
			PrivilegeCodes.GET_CANDIDATES_LOAD_SUMMARY,
			PrivilegeCodes.BULK_ASSIGN_FUNCTIONARY_TO_APPLICATION_FOR_REGION,
		],
	},
	{
		feature: 'Screening Dashboard',
		privilegeCodes: [
			PrivilegeCodes.GET_CANDIDATE_SCREENING_PROGRESS_SUMMARY,
			PrivilegeCodes.REASSIGN_FUNCTIONARY_TO_APPLICATION,
			PrivilegeCodes.UPDATE_REGION_ZONE_CENTER_OF_APPLICATION,
		],
	},
	{
		feature: 'Central Team Dashboard',
		privilegeCodes: [PrivilegeCodes.GET_CENTRAL_TEAM_DASHBOARD_DETAIL],
	},
	{
		feature: 'Pre-work Flow',
		privilegeCodes: [
			PrivilegeCodes.GET_PREWORK_APPLICATIONS,
			PrivilegeCodes.CAPTURE_PREWORK_MENTOR_ANSWERS,
		],
	},
	{
		feature: 'Dashboard',
		privilegeCodes: [
			PrivilegeCodes.GET_EXAMINATION_GRAPHICAL_VIEW,
			PrivilegeCodes.GET_EXAM_RESULT_GRAPHICAL_VIEW,
		],
	},
	{
		feature: 'Exams',
		privilegeCodes: [
			PrivilegeCodes.CREATE_EXAM,
			PrivilegeCodes.UPDATE_EXAM,
			PrivilegeCodes.IMPORT_ELIGIBLE_CANDIDATES_FOR_EXAM,
			PrivilegeCodes.SEND_EXAM_REGISTRATION_INVITE_EMAIL,
			PrivilegeCodes.SEND_EXAM_ADMIT_CARD_EMAIL,
			PrivilegeCodes.SEND_EXAM_RESULT_EMAIL,
			PrivilegeCodes.DOWNLOAD_CANDIDATE_EXAMINATION_DETAILS,
			PrivilegeCodes.UPLOAD_EXAM_RESULTS,
			PrivilegeCodes.PLACE_CANDIDATE_ON_HOLD,
			PrivilegeCodes.CHANGE_EXAMINATION_CENTER,
			PrivilegeCodes.APPROVE_HELD_CANDIDATE,
		],
	},
	{
		feature: 'Centers',
		privilegeCodes: [
			PrivilegeCodes.CREATE_EXAMINATION_CENTER,
			PrivilegeCodes.UPDATE_EXAMINATION_CENTER,
		],
	},
	{
		feature: 'Kanha-Invite',
		privilegeCodes: [
			PrivilegeCodes.CREATE_KANHA_BATCH,
			PrivilegeCodes.UPDATE_KANHA_BATCH,
			PrivilegeCodes.IMPORT_ELIGIBLE_CANDIDATES_FOR_KANHA_BATCH,
			PrivilegeCodes.SEND_KANHA_BATCH_INVITE_EMAIL,
			PrivilegeCodes.DOWNLOAD_KANHA_BATCH_CANDIDATE_DETAILS,
			PrivilegeCodes.UPLOAD_KANHA_BATCH_RESULTS,
		],
	},
	{
		feature: 'NPS/Pre-work Group Creation',
		privilegeCodes: [
			PrivilegeCodes.GET_PRECEPTORS,
			PrivilegeCodes.CREATE_PRECEPTOR_GROUP,
		],
	},
	{
		feature: 'NPS Groups List',
		privilegeCodes: [
			PrivilegeCodes.GET_PRECEPTOR_GROUPS,
			PrivilegeCodes.UPDATE_PRECEPTOR_GROUP,
			PrivilegeCodes.DELETE_PRECEPTOR_GROUPS,
			PrivilegeCodes.ASSIGN_MENTOR,
		],
	},
	{
		feature: 'View All New Preceptors',
		privilegeCodes: [PrivilegeCodes.GET_PRECEPTOR_DASHBOARD_CARD_DETAIL],
	},
	{
		feature: 'Graphical View',
		privilegeCodes: [PrivilegeCodes.GET_GRAPHICAL_VIEW],
	},
	{
		feature: 'NPS Batches',
		privilegeCodes: [
			PrivilegeCodes.GET_PRECEPTOR_BATCHES,
			PrivilegeCodes.CREATE_PRECEPTOR_BATCH,
			PrivilegeCodes.UPDATE_PRECEPTOR_BATCH,
			PrivilegeCodes.LOAD_PRECEPTORS_FROM_MYSRCM,
		],
	},
	{
		feature: 'Pre-work Group Creation',
		privilegeCodes: [
			PrivilegeCodes.GET_PREWORK_CANDIDATES,
			PrivilegeCodes.CREATE_PREWORK_GROUP,
		],
	},
	{
		feature: 'Pre-work Groups List',
		privilegeCodes: [
			PrivilegeCodes.GET_PREWORK_GROUPS,
			PrivilegeCodes.UPDATE_PREWORK_GROUP,
			PrivilegeCodes.ASSIGN_PREWORK_MENTOR,
		],
	},
	{
		feature: 'View All Candidates',
		privilegeCodes: [PrivilegeCodes.GET_PREWORK_DASHBOARD_METRICS],
	},
	{
		feature: 'Graphical View',
		privilegeCodes: [PrivilegeCodes.GET_PREWORK_GRAPHICAL_VIEW],
	},
	{
		feature: 'Functionaries List',
		privilegeCodes: [
			PrivilegeCodes.CREATE_OR_UPDATE_POSITION_ASSIGNMENT,
			PrivilegeCodes.BULK_UPLOAD_FUNCTIONARIES,
			PrivilegeCodes.DOWNLOAD_TEMPLATE_FOR_BULK_UPLOAD_FUNCTIONARIES,
			PrivilegeCodes.GET_FUNCTIONARY,
			PrivilegeCodes.GET_ALL_PREDEFINED_REASONS,
			PrivilegeCodes.REGISTER_FUNCTIONARY,
			PrivilegeCodes.GET_SIGNED_URL,
		],
	},
];
